import React, { useEffect } from "react";
import
  PropTypes
from 'prop-types';
import { PrimaryButton, SmallText, XLargeBoldText } from "../input/TextField.styles";
import { FlexArticle, FlexGrowArticle, PopUpContent } from "../popUp/PopUp.styles";
import errorIcon from '../../../images/error-icon.svg';
import { ErrorContainer, ImageIcon } from "./ErrorPage.styles";
import * as OtpTagging from '../../../tagging/OtpFormTagging';

export const ErrorPage = (props) => {

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Optional if you want to skip the scrolling animation
    });
  })
  return (
    <ErrorContainer>
      <PopUpContent>
      <ImageIcon width={'120px'} src={errorIcon} alt='errorIcon'/>

      <XLargeBoldText  style={{fontSize: '32px'}}>
        {props.errorMessage.heading}
      </XLargeBoldText>
      <FlexGrowArticle style={{gap: '40px'}}>
        <SmallText color={'#525365'}>
        {props.errorMessage.messageLine1}
          
          <br/>
        {props.errorMessage.messageLine2}

          
        </SmallText>
      </FlexGrowArticle>
      <PrimaryButton style={{ minWidth: '70px' }} onClick={() => { props.setIsError(false); OtpTagging.blockedOTPButtonClick(); }}>
        Okay, got it
      </PrimaryButton>
    </PopUpContent>
    </ErrorContainer>
  );
};

ErrorPage.propTypes = {
  errorMessage: PropTypes.object,
  setIsError: PropTypes.func
};

ErrorPage.defaultProps = {
  errorMessage: {},
  setIsError: ()=>{}
};

